import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserProfileOemMapping } from 'common/types/Entities';

import {
    APIUserProfilesByEmailGetList,
    APIUserProfilesByIdGetList
} from './UserProfiles.api';

export const fetchUserProfilesByEmail = createAsyncThunk('userProfiles/fetchUserProfilesByEmail', async (email: string) => {
    const response = await APIUserProfilesByEmailGetList({ email });
    return sortIdps(response.data);
});

export const fetchUserProfilesById = createAsyncThunk('userProfiles/fetchUserProfilesById', async (userId: string) => {
    const response = await APIUserProfilesByIdGetList({ userId });
    return sortIdps(response.data);
});

const sortIdps = (idpsList: UserProfileOemMapping[]) => idpsList.slice().sort((a, b) => {
    if (a.oemIdPId === import.meta.env.VITE_OEM_IDP_ID) {
        return 1;
    }
    if (a === b) {
        return 0;
    }
    return -1;
});
